export default "__VITE_ASSET__CCpFHdAF__"